import { useState } from 'react'
import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import type { DaoUrlDto } from '@/infra/api/generated/model'
import Modal from '@/src/components/modal/Modal'
import DaoGridHeightOption from './DaoGridHeightOption'

type DaoGridHeightModalProps = {
  daoUrls: DaoUrlDto[]
  isOpen: boolean
  handleSelect: (daoUrl: string) => void
  handleClose: () => void
}

const DaoGridHeightModal = ({
  daoUrls,
  isOpen,
  handleSelect,
  handleClose,
}: DaoGridHeightModalProps) => {
  const { t } = useTranslation('common')

  const [selectedDaoUrl, setSelectedDaoUrl] = useState<string | null>(null)

  const onValidate = () => {
    if (selectedDaoUrl) {
      handleSelect(selectedDaoUrl)
    }
  }

  const onModalClose = () => {
    setSelectedDaoUrl(null)
    handleClose()
  }

  return (
    <Modal
      title={t('pages.questions.dao-grid-height-modal.title')}
      isOpen={isOpen}
      handleOpen={() => {}}
      handleClose={onModalClose}
      closeOnClickOutside={false}
    >
      <div className="flex flex-col gap-4 pt-2">
        <p className="text-gray-800 text-base mb-2">
          {t('pages.questions.dao-grid-height-modal.description')}
        </p>

        <div className="flex flex-col gap-3">
          {daoUrls.map((daoUrlDto) => (
            <DaoGridHeightOption
              key={daoUrlDto.gridHeight}
              daoUrlDto={daoUrlDto}
              isSelected={selectedDaoUrl === daoUrlDto.daoUrl}
              onSelect={setSelectedDaoUrl}
            />
          ))}
        </div>

        <VpButton
          data-testid="dao-grid-height-submit-button"
          disabled={!selectedDaoUrl}
          className="w-full mt-4"
          shape="squared"
          onClick={onValidate}
        >
          {t('pages.questions.dao-grid-height-modal.validate')}
        </VpButton>
      </div>
    </Modal>
  )
}

export default DaoGridHeightModal
